import { render } from "./Pip360colorsMobile.vue?vue&type=template&id=e1c1a86e"
import script from "./Pip360colorsMobile.vue?vue&type=script&lang=js"
export * from "./Pip360colorsMobile.vue?vue&type=script&lang=js"

import "./Pip360colorsMobile.vue?vue&type=style&index=0&id=e1c1a86e&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__